import { actions } from "./action-list";

export function vehicleAllContractFetched(value) {
  return {
    type: actions.FETCH_VEHICLE_CONTRACTS,
    value,
  };
}
